import styles from "./BookingCancelModal.module.css";
import { useState } from "react";
import FullScreenLoader from "../Common/FullScreenLoader";
import MyAxios from "../axios/CustomAxios";
import { LoginIcon } from "../assets/icons/loginIcon";

const BookingCancelModal = ({
  cancelBookingInfo,
  cancelSlotInfo,
  closeModal,
  updateBookingData,
}) => {
  const [isLoading, setLoading] = useState(false);
  const [tryAgain, setTryAgain] = useState(false);

  const reFormatBookingDetail = () => {
    let existBookingInfo = JSON.parse(
      JSON.stringify(cancelSlotInfo.bookingFullInfo)
    );
    let slotPos = existBookingInfo.slotDetail.findIndex(
      (data) => data.slot_id == cancelSlotInfo.slotData.slot_id
    );

    let existSlotInfo = JSON.parse(JSON.stringify(cancelSlotInfo.slotData));
    let cancelTiming = cancelSlotInfo.cancelSlotTiming.timing;
    let cancelPricing = cancelSlotInfo.cancelSlotTiming.price;

    existSlotInfo.slotTotalAmount =
      existSlotInfo.slotTotalAmount - cancelPricing;

    existSlotInfo.slotAmount =
      existSlotInfo.slotAmount -
      cancelPricing / cancelSlotInfo.slotData.slotPlayers;

    //update slotCombinedTiming array
    existSlotInfo["canceledSlotCombinedTiming"] =
      existSlotInfo.slotCombinedTiming.splice(
        existSlotInfo.slotCombinedTiming.indexOf(cancelTiming),
        1
      );
    //update slotCombinedTiming array

    //update slotTimingAndPricing array
    const timingAndPricingPos = existSlotInfo.slotTimingAndPricing.findIndex(
      (info) => info.timing == cancelTiming
    );
    existSlotInfo["canceledSlotTimingAndPricing"] =
      existSlotInfo.slotTimingAndPricing.splice(timingAndPricingPos, 1);
    //update slotTimingAndPricing array

    //update slotTimings array
    const [startTime, endTime] = cancelTiming.split(" - ");
    let startPos, endPos;
    for (let i = existSlotInfo.slotTimings.length - 1; i >= 0; i--) {
      if (existSlotInfo.slotTimings[i].indexOf(startTime) == 0) {
        startPos = i;
      }
      if (existSlotInfo.slotTimings[i].indexOf(endTime) > 0) {
        endPos = i;
      }
    }
    existSlotInfo["canceledSlotTimings"] = existSlotInfo.slotTimings.splice(
      startPos,
      endPos - startPos + 1
    );
    //update slotTimings array

    existBookingInfo.slotDetail[slotPos] = existSlotInfo;
    existBookingInfo.totalBookingAmount = existBookingInfo.slotDetail.reduce((accumulated, slot) => {return slot.slotTotalAmount+accumulated}, 0);
    console.log(existBookingInfo);
    return existBookingInfo;
  };

  const onConfirmCancel = () => {
    setLoading(true);
    let req = {};
    if (cancelSlotInfo) {
      req = reFormatBookingDetail();
    } else {
      req = {
        bookingId: cancelBookingInfo?.bookingId,
        isBookingCancelled: true
      };
    }
    try{
    MyAxios.post(`/booking/cancel-booking`, req)
      .then(() => {
        updateBookingData(req);
      })
      .catch((error) => {
        console.error("Error fetching GD info:", error);
        setTryAgain(true);
      })
      .finally(() => {
        setLoading(false);
      });
    
    } catch (err) {
      console.error(err);
      localStorage.removeItem("token");
      window?.location?.reload && window.location.reload();
    }
  };

  return (
    <>
      <div className={styles.modal}>
        <div className={styles.modalContent}>
          <h2 className="mb0">{`Cancel ${
            cancelBookingInfo ? "Booking" : "Slot"
          }`}</h2>
          <h4 className="mb0">{`Are you sure want to cancel ${
            cancelBookingInfo
              ? cancelBookingInfo.slotDetail.length > 1
                ? "all slots in this booking"
                : "this booking"
              : "this slot"
          }`}</h4>
          {cancelBookingInfo && (
            <h4>
              {cancelBookingInfo.bookingId} - {cancelBookingInfo.date} -{" "}
              {cancelBookingInfo.totalBookingAmount}rs
            </h4>
          )}
          {cancelSlotInfo && (
            <h4>
              Date: {cancelSlotInfo.bookingFullInfo.date}
              <span className="captitalize ml10">
                {" "}
                {cancelSlotInfo.slotData.category} -{" "}
              </span>
              <span className="uppercase">
                {cancelSlotInfo.slotData.consoleType || ""}
              </span>{" "}
              -{" "}
              <span className="uppercase">
                {cancelSlotInfo.slotData.slotPlayers || ""} <LoginIcon />{" "}
              </span>
              <div>
                {" "}
                Each{" "}
                {cancelSlotInfo.cancelSlotTiming.price /
                  cancelSlotInfo.slotData.slotPlayers}
                rs - Total {cancelSlotInfo.cancelSlotTiming.price}
                rs
              </div>
              <div className="mt10">Timing:</div>
              {cancelSlotInfo?.cancelSlotTiming?.timing}
            </h4>
          )}
          {tryAgain && <div className={`mb15`}> Cancellation Failed !!! Wants to try again..? </div>}
          <div className={styles.modalActions}>
            <button onClick={onConfirmCancel}>Yes</button>
            <button onClick={closeModal}>No</button>
          </div>
        </div>
      </div>
      {isLoading && <FullScreenLoader />}
    </>
  );
};

export default BookingCancelModal;
